<template>
    <v-container>
        <v-layout>
            <v-flex>
                <v-jumbotron :dark="luz">
                    <v-container fill-height>
                        <v-layout align-center>
                            <v-flex text-xs-center>
                                <img :src="(luz)?'./img/ltn-negro.svg' : './img/ltn-blanco.svg'" alt="Logo">
                                <br>
                                <br>
                                <template v-if="!isLoggedIn">
                                    <v-btn to="/login" flat exact>INGRESAR</v-btn>
                                    <!--<router-link :to="{ name: 'register' }"> REGISTER</router-link>-->
                                </template>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-jumbotron>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import {mapGetters} from 'vuex'

    export default {
        layout: 'default',
        data() {
            return {
                mensaje: 'todo ok'
            }
        },
        computed: {
            ...mapGetters('auth', ['isLoggedIn']),
            ...mapGetters('config', ['luz']),
        },
    }
</script>
<style scoped>
    .content--wrap {
        background: linear-gradient(to top, rgb(130, 143, 152), rgb(29, 26, 21));
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/welcome.vue